import React, { useState, useEffect } from "react";
import "../assets/css/navbar.css";
import taxFreeLogo from "../assets/img/tax_free_retirement_council.png";
import { useLocation } from "react-router-dom";
import { usePanel } from "./PanelContext";
import { metaTrackButtonClick } from "./MetaPixelFunctions";

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentHeader, setCurrentHeader] = useState<string>("home");
  const location = useLocation();
  const { togglePanel } = usePanel();
  useEffect(() => {
    const path = location.pathname;
    if (path === "/") setCurrentHeader("home");
    else if (path.includes("about")) setCurrentHeader("about-us");
    else if (path.includes("services")) setCurrentHeader("services");
  }, [location.pathname]);
  return (
    <div className="navbar">
      <div className="navbar-container">
        <div className="navbar-left">
          <a href="/" className="logo">
            <img className="Home-Button" src={taxFreeLogo} />
          </a>
        </div>
        {menuOpen && <div className="hamburger-side-bar"></div>}

        <div className={`navbar-center${menuOpen ? "open" : ""}`}>
          <ul className="nav-links">
            <li className={currentHeader === "home" ? `active-header` : ""}>
              <a
                href="/"
                onClick={() => {
                  setMenuOpen(false);
                }}
              >
                Home
              </a>
            </li>
            <li className={currentHeader === "about-us" ? `active-header` : ""}>
              <a
                href="/about"
                onClick={() => {
                  setMenuOpen(false);
                }}
              >
                About Us
              </a>
            </li>
            {/* <li className={currentHeader === "services" ? `active-header` : ""}> */}
            {/*   <a */}
            {/*     href="/services" */}
            {/*     onClick={() => { */}
            {/*       setMenuOpen(false); */}
            {/*     }} */}
            {/*   > */}
            {/*     Services */}
            {/*   </a> */}
            {/* </li> */}
          </ul>
        </div>
        <div className={`navbar-right${menuOpen ? "open" : ""}`}>
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>

          {/* <a className="test-button" href="/assessment"> */}
          {/*   Get My Free Book & Consultation */}
          {/* </a> */}
          <button
            className="test-button"
            onClick={() => {
              metaTrackButtonClick();
              togglePanel();
              document.body.classList.remove("no-scroll");
            }}
          >
            Get My Free Book & Consultation
          </button>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
